import analytics from "../../analytics/analytics.js";
import { createBasketRequest } from "../../graphQLRequest/createBasketRequest.js";
const handleRentalCarBookNowClick = ({ rentalCarRate, isMobile, cguid, rguid })=>function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (rentalCarRate && rentalCarRate?.detailsInfo?.itemKey && rentalCarRate?.detailsKey) {
            analytics.log({
                label: 'RentalCarSearchResult',
                message: 'RENTAL_CAR_CHECKOUT_LINK_CLICKED',
                ...rentalCarRate.finalRequestArgs
            });
            const priceKey = rentalCarRate.detailsKey;
            const itemKey = rentalCarRate.detailsInfo?.itemKey;
            createBasketRequest({
                itemType: 'DRIVE',
                appc: isMobile ? 'MOBILEWEB' : 'DESKTOP',
                cguid,
                rguid,
                itemKey,
                priceKey,
                total: rentalCarRate.totalPrice,
                minCurrencyCode: rentalCarRate.currencyCode || 'USD',
                minCurrencyCodeSymbol: rentalCarRate.currencySymbol || '$'
            });
            return;
        }
        analytics.log({
            label: 'RentalCarSearchResult',
            message: 'RENTAL_CAR_CHECKOUT_LINK_CLICKED',
            status: 'NO_RATE_FOUND',
            ...rentalCarRate?.finalRequestArgs
        });
    };
export { handleRentalCarBookNowClick };
